<template>
  <div>
    <SignupForm :fromPage="fromPage" @signupSuccess="handleSignupSuccess"></SignupForm>
  </div>
</template>

<script>
import SignupForm from '@/components/SignupComps/SignupForm.vue';

export default {
  name: "Signup",
  components: {
    SignupForm
  },
  data() {
    return {
      fromPage: null
    }
  },
  created() {
    // 获取来源页面参数
    this.fromPage = this.$route.query.from || null;
  },
  methods: {
    // 注册成功后跳转：优先 redirect/returnUrl，否则 checkout 去 /checkout，其余去首页
    handleSignupSuccess() {
      const redirect = this.$route.query.redirect || this.$route.query.returnUrl;
      const path = (typeof redirect === 'string' && redirect.trim() && redirect.startsWith('/'))
        ? redirect.trim()
        : (this.fromPage === 'checkout' ? '/checkout' : '/');
      this.$router.replace(path);
    }
  }
};
</script>

<style lang="scss" scoped>
// 页面样式可以在这里添加
</style>
